import { Component, OnDestroy, OnInit } from '@angular/core';
import { BillInterface } from '../../models/bill.interface';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { BillsInterfaceState } from '../../store/state/bills.state';
import { DownloadBill, GetBills } from '../../store/actions/bills.actions';
import { BillInterfaceState } from '../../store/state/bill.state';
import { GetCustomerProcedures } from '../../../lines/store/actions/customer-procedures.actions';
import { SelectedProcedureInterfaceState } from '../../../shared/store/state/selected-procedure.state';
import { CustomerProcedureInterface } from '../../../lines/models/customer-procedure.interface';
import { CustomerProcedureInterfaceState } from '../../../lines/store/state/customer-procedure.state';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { AlertMessageInterface } from '../../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import {
  DeleteCustomerNotifications,
  GetCustomerNotifications
} from '../../../shared/store/actions/customer-msisdn-notifications.actions';
import { CustomerMsisdnNotificationPaginatorInterface } from '../../../shared/models/customer-msisdn-notification-paginator.interface';
import { MsisdnNotificationsInterfaceState } from '../../../shared/store/state/msisdn-notifications.state';
import { SaveCustomerMission } from '../../../shared/store/actions/customer-mission.actions';
import { BillService } from '../../services/bill.service';
import { environment } from '../../../../../environments/environment';
import * as FileSaver from 'file-saver';
import { PaymentsPaginatorInterface } from '../../../payments/models/payments.paginator.interface';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { PriceFormatService } from '../../../shared/services/price-format.service';
import { PaymentsService } from '../../../payments/services/payments.service';
import { CustomerStorageService } from '../../../account/services/customer-storage.service';
import { CustomerInterface } from '../../../account/models/customer.interface';
import { PartnerPaymentService } from '../../../shared/services/partner-payment.service';
import { ExtranetService } from '../../../shared/services/extranet.service';
import { SupportUserInterface } from '../../../shared/models/support-user.interface';
import moment from 'moment';
import { InvoiceLifecycleInterface } from '../../models/invoice-lifecycle.interface';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-bills-list',
  templateUrl: './bills-list.component.html',
  styleUrls: ['./bills-list.component.css'],
  standalone: false
})
export class BillsListComponent implements OnInit, OnDestroy {

  invoiceLifeCycle: Array<InvoiceLifecycleInterface>|null;
  bills: Array<BillInterface> = [];
  selectedBill: BillInterface;
  firstBill: BillInterface;
  customer: CustomerInterface;
  notificationsPaginator: CustomerMsisdnNotificationPaginatorInterface;
  activeProceduresList: Array<CustomerProcedureInterface> = [];
  inProgressProceduresList: Array<CustomerProcedureInterface> = [];
  visibility: boolean = false;
  arrowImage: string = 'arrow_down';
  selectedProcedure: string = null;
  step: number;
  environment = environment;
  constHelper = ConstsHelper;
  payments: PaymentsPaginatorInterface;
  billManagementTab: string;
  billsTab: string;
  notificationsTab: string;
  debitText: string;
  faqPageCode: string;
  supportUser: SupportUserInterface;
  amount: number;
  procedureInParam: string;
  brand?: string;
  private destroy$ = new Subject<void>();

  constructor(
      private store: Store<any>,
      private billService: BillService,
      private location: Location,
      public priceFormatService: PriceFormatService,
      private paymentsService: PaymentsService,
      private customerStorageService: CustomerStorageService,
      private activateRoute: ActivatedRoute,
      private extranetService: ExtranetService,
      private partnerPaymentService: PartnerPaymentService
  ) {}

  ngOnInit() {
    this.invoiceLifeCycle = null;
    this.store.pipe(select(ConstsHelper.REDUCER_BILLS), takeUntil(this.destroy$)).subscribe((response: BillsInterfaceState) => {
      console.log(response.bills instanceof Array, this.bills.length)
      if (response.bills instanceof Array && this.bills.length === 0) {
        this.debitText = null;
        this.bills = response.bills;
        this.invoiceLifeCycle = null;
        this.selectedBill = this.bills[0];
        this.getInvoiceLifecycle();
        this.firstBill = this.bills[0];
        this.paymentsService.get(1, 10).subscribe(payments => {
          this.amount = payments.total;
          this.payments = payments;
          if (this.payments.total === 0) {
            this.debitText = 'Cette facture a été payée le ' + this.payments.data[0].date;
          }
          this.partnerPaymentService.getCards().subscribe(cards => {
            this.paymentsService.getSchedule(parseInt(this.firstBill.month, 10), 12).subscribe(result => {
              if (cards.length > 0) {
                for (const card of cards) {
                  if (card.isSelected && this.debitText === null) {
                    this.debitText = 'Cette somme sera prélevée sur votre carte à partir du ' + result[0].levyDate;
                  }
                }
              } else if (this.debitText === null) {
                this.debitText = 'Cette somme sera prélevée sur votre compte à partir du ' + result[0].levyDate;
              }
            }, error => {
              if (cards.length > 0) {
                for (const card of cards) {
                  if (card.isSelected && this.debitText === null) {
                    this.debitText = 'Rendez-vous dans Gestion de mes factures pour payer votre facture.';
                  }
                }
              } else if (this.debitText === null) {
                this.debitText = 'Rendez-vous dans Gestion de mes factures pour payer votre facture.';
              }
            });
          });
        });
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_BILL), takeUntil(this.destroy$)).subscribe((response: BillInterfaceState) => {
      if (response.bill != null) {
        this.selectedBill = response.bill;
        this.invoiceLifeCycle = null;
        this.getInvoiceLifecycle();
        this.store.dispatch(new GetCustomerProcedures('bill', this.selectedBill.id.toString()));
      }
      this.visibility = false;
      this.arrowImage = 'arrow_down';
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER_PROCEDURES), takeUntil(this.destroy$)).subscribe((response: CustomerProcedureInterfaceState) => {
      if (null !== response.customerProcedures) {
        this.paymentsService.get(1, 10).subscribe(payments => {
          this.payments = payments;
          this.activeProceduresList = [];
          this.inProgressProceduresList = [];
          let i = 0;
          for (const procedure of response.customerProcedures) {
            if (
                procedure.status === 'finished' &&
                procedure.visibility &&
                (
                    procedure.code !== this.constHelper.PROCEDURE_EXPRESS_PAYMENT ||
                    (procedure.code === this.constHelper.PROCEDURE_EXPRESS_PAYMENT && this.brand === 'coriolis') ||
                    (procedure.code === this.constHelper.PROCEDURE_EXPRESS_PAYMENT && this.brand !== 'coriolis' && this.payments.total > 0)
                )
            ) {
              this.activeProceduresList.push(procedure);
            } else if (procedure.visibility && procedure.status !== 'finished') {
              this.inProgressProceduresList.push(procedure);
            }
            i++;
            if (i === response.customerProcedures.length) {
              this.handleProcedures();
            }
          }
        });
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER_MSISDN_NOTIFICATIONS), takeUntil(this.destroy$)).subscribe((response: MsisdnNotificationsInterfaceState) => {
      if (response.result != null) {
        this.notificationsPaginator = response.result;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_SELECTED_PROCEDURE), takeUntil(this.destroy$)).subscribe((response: SelectedProcedureInterfaceState) => {
      if (response.code != null) {
        this.selectedProcedure = response.code;
      }
    });

    this.brand = environment.data.brand;
    this.customer = this.customerStorageService.getCustomer();
    this.amount = null;
    this.debitText = null;
    if (this.activateRoute.snapshot.params['procedure'] === 'payer-facture') {
      this.procedureInParam = this.activateRoute.snapshot.params['procedure'];
    }
    this.supportUser = this.extranetService.getSupportUser();
    this.store.dispatch(new GetCustomerNotifications('bill', 1, 5));
    this.store.dispatch(new GetBills());
    this.setActiveTab(this.activateRoute.snapshot.params['tab'], true);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  sendBillDetailsRequest(version: string) {
    let mimeType = 'application/octet-stream';
    let fileName = 'Facture-Détaillée-' + this.selectedBill.id + '.xlsx';
    if (version === 'pdf') {
      mimeType = 'application/pdf';
      fileName = 'Facture-Détaillée-' + this.selectedBill.id + '.pdf';
    }
    this.billService.downloadFileByParams(
        {
          extension: version === 'pdf' ? 'pdf' : 'xlsx',
          billingId: this.selectedBill.id,
          fileTypeSlug: this.environment.data.detailedBillFileTypeSlug
        }
    ).subscribe(
        response => {
          FileSaver.saveAs(new Blob([response], { type: mimeType }), fileName);
        },
        err => {
          this.store.dispatch(
              new SaveCustomerMission(
                  {
                    externalId: this.selectedBill.id.toString(),
                    step: 1,
                    version
                  },
                  ConstsHelper.PROCEDURE_BILL_DETAILS,
                  'bill'
              )
          );
        }
    );
  }

  getProcedure(procedure: CustomerProcedureInterface) {
    this.step = procedure.nextStep;
    if (procedure.code === ConstsHelper.PROCEDURE_EXPRESS_PAYMENT && !this.location.path().includes('payer-facture')) {
      this.location.replaceState(this.location.path() + '/payer-facture');
    }
    this.store.dispatch(new UpdateSelectedProcedure(procedure.code));
  }

  displayMessage(procedure: CustomerProcedureInterface) {
    let alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_BY_SUPPORT, code: 300 } as AlertMessageInterface;
    if (procedure.status === ConstsHelper.PROCEDURE_STATUS_IN_PROGRESS) {
      alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION, code: 300 } as AlertMessageInterface;
    }
    this.store.dispatch(new GetAlertMessage(alertMessage));
  }

  downloadBill() {
    const filename = this.selectedBill.period.replace(' ', '-');
    this.store.dispatch(new DownloadBill(this.selectedBill.id, 'Facture-' + filename, 'application/pdf'));
  }

  displayBillsList() {
    if (this.selectedProcedure == null || this.selectedProcedure === '') {
      this.visibility = true;
      this.arrowImage = 'arrow_up';
    }
  }

  setActiveTab(tab: string, withParams: boolean) {
    this.billManagementTab = '';
    this.billsTab = '';
    this.notificationsTab = '';
    if (['', 'undefined', undefined].indexOf(tab) !== -1) {
      tab = 'liste';
      this.faqPageCode = 'bill_liste';
    }
    switch (tab) {
      case 'liste':
        this.billsTab = 'active';
        this.faqPageCode = 'bill_liste';
        break;
      case 'gestion':
        this.store.dispatch(new GetCustomerProcedures('bill', null));
        this.billManagementTab = 'active';
        this.faqPageCode = 'bill_gestion';
        break;
      case 'notifications':
        this.notificationsTab = 'active';
        this.faqPageCode = 'bill_notifications';
        if (
            this.notificationsPaginator &&
            this.notificationsPaginator.totalUnread > 0 &&
            this.notificationsPaginator.data.length > 0 &&
            this.supportUser == null
        ) {
          this.store.dispatch(new DeleteCustomerNotifications(this.notificationsPaginator.data[0].id));
        }
        break;
    }
    this.store.dispatch(new UpdateSelectedProcedure(''));
    let url = '/factures/' + tab;
    if (this.procedureInParam && withParams) {
      url += '/' + this.procedureInParam;
    } else {
      this.procedureInParam = '';
    }
    this.location.replaceState(url);
  }

  handleProcedures() {
    const tmpActiveProceduresList = this.activeProceduresList;
    for (const procedure of tmpActiveProceduresList) {
      if (procedure.code === this.constHelper.PROCEDURE_EXPRESS_PAYMENT) {
        let tempBlock = false;
        const localStorageBlockExpressPaymentProcedure = ConstsHelper.LOCAL_STORAGE_TEMPORARILY_BLOCK_EXPRESS_PAYMENT_PROCEDURE + '_' + this.customer.id;
        if (localStorage.getItem(localStorageBlockExpressPaymentProcedure)) {
          const data = JSON.parse(localStorage.getItem(localStorageBlockExpressPaymentProcedure));
          if (parseInt(moment(new Date()).subtract(30, 'minute').format('YYYYMMDDHHmm'), 10) < parseInt(data.date, 10)) {
            tempBlock = true;
          } else {
            localStorage.removeItem(localStorageBlockExpressPaymentProcedure);
          }
        }
        if (this.payments.total <= 0 && this.brand !== 'coriolis') {
          const index = tmpActiveProceduresList.indexOf(procedure);
          tmpActiveProceduresList.splice(index, 1);
          this.activeProceduresList = tmpActiveProceduresList;
          localStorage.removeItem(localStorageBlockExpressPaymentProcedure);
        } else if (this.payments.total > 0 && this.procedureInParam === 'payer-facture' && !tempBlock) {
          localStorage.removeItem(localStorageBlockExpressPaymentProcedure);
          this.getProcedure(procedure);
        } else if (this.payments.total > 0 && tempBlock) {
          const index = tmpActiveProceduresList.indexOf(procedure);
          tmpActiveProceduresList.splice(index, 1);
          this.activeProceduresList = tmpActiveProceduresList;
          procedure.status = 'in_progress';
          this.inProgressProceduresList.push(procedure);
        }
      }
    }
  }

  getStatusClassname(statusCode: number) {
    let className = null;
    if ([200,201,202,203,204,205,211,212].indexOf(statusCode) !== -1) {
      className = 'green';
    } else if (206 === statusCode) {
      className = 'blue';
    } else if ([207, 208, 209].indexOf(statusCode) !== -1) {
      className = 'orange';
    } else {
      className = 'red';
    }

    return className;
  }

  getReason(lifecycle: InvoiceLifecycleInterface) {
    const str = lifecycle.reason.split('-');
    if (str.length > 0) {
      return str[0] + ' le ' + lifecycle.date;
    }
    return '';
  }

  formatNote(note: string) {
    return note.replace(/-/g, '<br/>- ')
  }

  private getInvoiceLifecycle() {
    if ([null, ''].indexOf(this.customerStorageService.getCustomer().siret) == -1 && this.invoiceLifeCycle === null) {
      this.billService.getInvoiceLifecycle(this.selectedBill.id).subscribe(
          response => {
            this.invoiceLifeCycle = response;
          }
      );
    }
  }
}
